import { gql } from "@apollo/client";

const WorkingModelQueryEn = gql`
  query MyQuery {
    nodeWorkingModels(first: 10, langcode: "en") {
      nodes {
        __typename
        workingModelPointsSecti {
          ... on ParagraphWorkingModelPoint {
            id
            pointsDescription
            pointsTitle
            iconWithWorkingModelPo {
              url
              alt
            }
          }
        }
        workingModelTableSectio {
          ... on ParagraphWorkingModelTablePoint {
            id
            tablePoints
            tableTitle
          }
        }
        title
        path
        bannerImage {
          url
        }
        body {
          value
        }
      }
    }
  }
`;
export default WorkingModelQueryEn;
